/**
 * @namespace InvoiceHelpers
 */
const InvoiceHelpers = {};

//------------------------------------------------------------------------------
/**
 * @summary BASIC DATE FORMAT - formats the ISOdate for something like an event.
 * @param {date} date - Date in ISO format
 * @return {string} string - Formatted date
 */
InvoiceHelpers.getDiscountAmount = (discountValue = 0, discountType, discountAmount, subtotal) => {
  // if discountValue is a string, try to remove the commas
  if (typeof discountValue === 'string') {
    discountValue = discountValue.replace(/,/g, '');
  }

  if (isNaN(discountValue)) {
    throw new Error('InvoiceHelpers.getDiscountAmount discountValue must be a number');
  }
  if (isNaN(discountAmount)) {
    throw new Error('InvoiceHelpers.getDiscountAmount discountAmount must be a number');
  }
  if (isNaN(subtotal)) {
    throw new Error('InvoiceHelpers.getDiscountAmount subtotal must be a number');
  }

  if (discountType === 'percentage') {
    let cleanDiscountValue = parseFloat(discountValue || 0, 10);
    discountAmount = subtotal * (cleanDiscountValue / 100);
  }
  if (discountType === 'dollar-amount') {
    discountAmount = (discountValue && discountValue.toString().replace('.', '')) || '0';
  }
  return discountAmount;
};

//------------------------------------------------------------------------------
/**
 * @summary BASIC DATE FORMAT - formats the ISOdate for something like an event.
 * @param {date} date - Date in ISO format
 * @return {string} string - Formatted date
 */
InvoiceHelpers.getSubTotal = (keys, newState) => {
  let subtotal = 0;
  if (keys && keys.length > 0) {
    keys.forEach(k => {
      let input = newState[`names-${k}`];
      if (input) {
        let inputValue = input || 0;
        if (inputValue && inputValue.amount) {
          if (inputValue.amount !== '0.00') {
            let inputAmountInCents = inputValue.amount.toString().replace('.', '');
            subtotal += parseInt(inputAmountInCents);
          }
        }
      }
    });
  }
  return subtotal;
};

//------------------------------------------------------------------------------
/**
 * @summary BASIC DATE FORMAT - formats the ISOdate for something like an event.
 * @param {date} date - Date in ISO format
 * @return {string} string - Formatted date
 */
InvoiceHelpers.getTax = (salesTax = 0, subtotal) => {
  if (isNaN(subtotal)) {
    throw new Error('InvoiceHelpers.getTax subtotal must be a number');
  }
  if (isNaN(salesTax) || salesTax === null) {
    salesTax = 0;
  }

  let cleanSalesTax = parseFloat(salesTax);
  let tax = parseFloat(subtotal) * (cleanSalesTax / 100); // tax is somethings a decimal, so we need to round it... see taxInCents
  let taxInCents = tax.toFixed() / 1; // toFixed returns a string for some reason, so dividie by 1 to get it back to number https://stackoverflow.com/questions/2283566/how-can-i-round-a-number-in-javascript-tofixed-returns-a-string
  return taxInCents;
};

//------------------------------------------------------------------------------
/**
 * @summary BASIC DATE FORMAT - formats the ISOdate for something like an event.
 * @param {date} date - Date in ISO format
 * @return {string} string - Formatted date
 */
InvoiceHelpers.getLineItems = newState => {
  let keys = newState.keys;
  let lineItems = keys.map(k => {
    let item = newState[`names-${k}`];
    if (!item) {
      return { description: '', amount: 0 };
    }
    return item;
  });
  return lineItems;
};

export default InvoiceHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/InvoiceHelpers/index.js